import axios from "./index";

export default {
  fetch(callback) {
    axios.get("/api/v1/developer_permissions").then(response => {
      callback(response.data);
    }).catch(error => {
      console.log(error);
      callback(null);
    });
  }
};
